var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.done)?_c('div',{staticClass:"liberty-notice"},[_c('div',{staticClass:"sitenotice"},[(_vm.item.text)?_c('viewer',{ref:"viewer",attrs:{"initialValue":_vm.item.text}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }